import React, { useRef } from "react";
import { Carousel } from "react-bootstrap";
import { REMOTE_BASE_URL } from "../../../../constants";

import { processImagePath } from "../../../../util/Functions";

// import mediumZoom from 'medium-zoom'
import mediumZoom from 'medium-zoom/dist/pure'
import 'medium-zoom/dist/style.css'
import './ProductMedia.scss';



import "../InnerImageZoom.scss";

function ProductMedia({ media }) {
	const vidRef = useRef(null);

	const handleVideoClick = () => vidRef.current.requestFullscreen();

	const processMedia = (mediaToProcess, key) =>
		['', 'image'].includes(mediaToProcess.type ?? "")
			? processImage(mediaToProcess, key)
			: processVideo(mediaToProcess, key);

	const onImageLoadError = React.useCallback(e => {
		console.warn("Failed to load product image", e.target.src);
		e.target.parentElement.classList.add("image-error");
	}, []);

	const processImage = (media, key) => {
		return (
			<Carousel.Item key={key}>
				<img
					src={processImagePath(media.source, "zoom")}
					data-zoom="true"
					onError={onImageLoadError}
					onLoad={e => mediumZoom(e.target, {
						margin: 0,
					})} />
			</Carousel.Item>
		);
	};
	// mediumZoom('[data-zoom]')
	const processVideo = (media, key) => {
		return (
			<Carousel.Item key={key}>
				<video
					ref={vidRef}
					autoPlay
					loop
					muted
					onClick={handleVideoClick}
					playsInline
					className="d-block w-100"
					src={processImagePath(media.source)}
					alt=""
				/>
			</Carousel.Item>
		);
	};

	if (!media?.length) return (<></>);

	return (
		<div className="product-media-orig">
			{
				media?.length > 1 ? (
					<Carousel variant="dark" data-count={media?.length} interval={null}>
						{media && media.map(processMedia)}
					</Carousel>
				) : (
					<picture>
						<img src={processImagePath(media.at(0).source, "full")} onError={onImageLoadError} alt="" />
					</picture>
				)
			}
		</div>
	);
}

export default ProductMedia;
